angular.module('theme').directive('videoSize', function ($window) {
	return {
		restrict: 'A',
		scope: {
			videoWidth: '<',
			videoHeight: '<',
		},
		link: function ($scope, $element) {
			var videoContentContainer = angular.element(
				document.querySelector('#video-content')
			);

			var calculateSize = function () {
				var videoHeight = $element[0].offsetHeight;
				videoContentContainer.css('margin-top', videoHeight + 'px');
			};

			calculateSize();

			angular.element($window).bind('resize', function () {
				calculateSize();
				$scope.$digest();
			});

		}
	};
});
